// validation/infoValidation.ts
import * as Yup from 'yup';

const persianRegex = /^[\u0600-\u06FF\s]+$/;

export const infoValidationSchema = Yup.object().shape({
  deliveryDate: Yup.string().required('زمان تامین کالا الزامی است'),

  deliveryType: Yup.string()
    .required('نوع تحویل الزامی است')
    .oneOf(['in-person', 'seller'], 'نوع تحویل نامعتبر است'),

  recipientName: Yup.string().when('deliveryType', {
    is: 'seller',
    then: schema =>
      schema
        .required('نام و نام خانوادگی گیرنده الزامی است')
        .min(2, 'نام باید حداقل ۲ کاراکتر باشد')
        .matches(persianRegex, 'نام باید فقط شامل حروف فارسی باشد'),
    otherwise: schema => schema.notRequired(),
  }),

  state: Yup.string().when('deliveryType', {
    is: 'seller',
    then: schema => schema.required('استان الزامی است'),
    otherwise: schema => schema.notRequired(),
  }),

  city: Yup.string().when('deliveryType', {
    is: 'seller',
    then: schema => schema.required('شهر الزامی است'),
    otherwise: schema => schema.notRequired(),
  }),

  address: Yup.string().when('deliveryType', {
    is: 'seller',
    then: schema =>
      schema
        .required('آدرس گیرنده الزامی است')
        .min(10, 'آدرس باید حداقل ۱۰ کاراکتر باشد'),
    otherwise: schema => schema.notRequired(),
  }),

  plateNumber: Yup.number()
    .nullable()
    .when('deliveryType', {
      is: 'seller',
      then: schema =>
        schema
          .required('شماره پلاک الزامی است')
          .typeError('شماره پلاک باید عدد باشد')
          .test(
            'max-length',
            'شماره پلاک حداکثر ۷ رقم است',
            value =>
              value === null ||
              value === undefined ||
              String(value).length <= 7,
          ),
      otherwise: schema => schema.notRequired(),
    }),

  postalCode: Yup.number()
    .nullable()
    .when('deliveryType', {
      is: 'seller',
      then: schema =>
        schema
          .required('کد پستی الزامی است')
          .typeError('کد پستی باید عدد باشد')
          .test(
            'exact-length',
            'کد پستی باید دقیقاً ۱۰ رقم باشد',
            value =>
              value !== null &&
              value !== undefined &&
              String(value).length === 10,
          ),
      otherwise: schema => schema.notRequired(),
    }),
});
